import styled, { css } from 'styled-components';

export const StyledButton = styled.button(
  ({ theme, backgroundColor = 'oxfordBlue', height = 'h5', disabled }) => css`
    background-color: ${theme.colors[backgroundColor]};
    color: ${theme.colors.white};
    width: ${theme.width.full};
    border: none;
    border-radius: ${theme.radius.s};
    font: inherit;
    font-size: ${theme.fontSize.xs};
    font-weight: ${theme.fontWeight.semiBold};
    height: ${theme.height[height]};
    opacity: ${disabled ? 0.3 : 1};
  `
);

export const StyledOutlinedButton = styled.button(
  ({
    theme,
    backgroundColor = 'oxfordBlue',
    inverted,
    height = 'h5',
    disabled,
  }) => css`
    background-color: ${inverted
      ? theme.colors.white
      : theme.colors[backgroundColor]};
    color: ${inverted ? theme.colors[backgroundColor] : theme.colors.white};
    width: ${theme.width.full};
    border-width: 1px;
    border-color: ${inverted
      ? theme.colors[backgroundColor]
      : theme.colors.white};
    border-radius: ${theme.radius.s};
    font: inherit;
    font-size: ${theme.fontSize.xs};
    font-weight: ${theme.fontWeight.semiBold};
    height: ${theme.height[height]};
    opacity: ${disabled ? 0.3 : 1};
  `
);

export const ButtonBlockRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 0 ${({ theme }) => theme.spacing.m};
`;
